// 背景カラー
export const BGDefaultColor = "#FFFCD6";
export const BGChangeColor = "#FFFFFF";
export const BGDisabledColor = "rgba(0, 0, 0, 0.06)";
export const BGErrorColor = "#FFD6D6";
// テキストカラー
export const TextDefaultColor = "rgba(0, 0, 0)";
export const TextChangeColor = "rgba(0, 0, 255, 1)";
export const TextDisabledColor = "rgba(0, 0, 0, 0.38)";
// ボーダーカラー
export const BorderDefaultColor = "rgba(0, 0, 0, 0.23)"; //活性と非活性
export const BorderHoverColor = "rgba(0, 0, 0, 0.87)";
export const BorderFocusedColor = "#1976d2";
export const BorderErrorColor = "red";

interface tableType {
    [key: string]: any; // <-この行を追加!
}
export const table_name = {
    表紙: "location_cover",
    出店条件: "location_storeopeningconditions",
    商圏: "location_trade_area",
    現況写真: "location_pictuer",
    寄付き: "location_donation",
    通行量5m外: "location_traffic_5mcut",
    通行量: "location_traffic",
    競合: "location_conflict",
    影響度: "location_impact",
    図面: "location_drawing",
} as tableType;
export const getTableName = (key: string) => {
    return key in table_name ? table_name[key] : "";
};